import { useTranslation } from 'react-i18next';
import React, { useContext, useState, useEffect } from "react"
import ListComponent from "@/components/listComponent"
import { getBussinessCategoryList,  bussinessCategoryDelete, bussinessCategoryUpdate } from "@/service/dataService"
import { MyContext } from "@/store/myContext"
import Detail from "./detail"
import { Modal, Image } from "antd"
import {fileLookUrl } from "@/config/app.js"
import { AccountClassStatus } from "@/utils/enum"

export default () => {
    
const { t } = useTranslation();
const { state, message } = useContext(MyContext)
    const [showVisible, setShowVisible] = useState(false)
    const [showMode, setShowMode] = useState("")
    const [list, setList] = useState([]) //列表
    const [searchValue] = useState({})
    const [pagination, setpagination] = useState({
        //分页配置
        total: 0,
        current: 1,
        pageSize: 10,
    })
    const [selectInfo, setSelectInfo] = useState({ rowInfo: {}, rowIndex: -1 }) //记录当前行下标及信息


    useEffect(() => {
        if (state.activeMenu === "accountClass") {
            loadData(pagination.current)
        }
    }, [state.activeMenu])

    //列表数据
    const loadData = (current, search = {}) => {
        let data = {
            searchItem: { disableFlag: 0, ...search },
            pageNum: current,
            pageSize: 10,
            orders: [
                {
                    column: "updateTime",
                    rule: "DESC",
                },
            ],
        }
        getBussinessCategoryList(data).then((res) => {
            setpagination({
                current: current,
                total: res.retData.total,
                pageSize: 10,
            })
            setSelectInfo({ rowInfo: {}, rowIndex: -1 })
            setList(res.retData.list)
        })
    }
    //分页事件 置空当前行信息
    const onTableChange = async (page) => {
        await setpagination({
            ...pagination,
            current: page.current,
        })
        loadData(page.current, searchValue)
    }

    //列表button
    const topButtons = [
        {
            click: () => handleDetails("insert"),
            content: t(`dataManage.accountClass.index.新增`),
        },
        {
            click: () => handleDetails("edit"),
            content: t(`dataManage.accountClass.index.编辑`),
        },
        {
            click: () => handleDelete(),
            content: t(`dataManage.accountClass.index.删除`),
        },
    ]

    //删除
    const handleDelete = async () => {
        if (!Object.keys(selectInfo.rowInfo).length) {
            message.warning(t(`dataManage.accountClass.index.请选择你要删除的账目分类信息`))
            return
        }
        const modal = Modal.confirm({
            content: `${t(`dataManage.accountClass.index.确定要删除该账目分类`)}?`,
            okText: t(`dataManage.accountClass.index.确定`),
            cancelText: t(`dataManage.accountClass.index.取消`),
            centered: true,
            onOk() {
                bussinessCategoryDelete(selectInfo.rowInfo.id).then((res) => {
                    message.success(t(`dataManage.accountClass.index.删除成功`))
                    loadData(pagination.current, searchValue)
                })
            },
        })
    }
    //新增
    const handleDetails = async (mode) => {
        if (mode === "edit") {
            if (!Object.keys(selectInfo.rowInfo).length) {
                message.warning(t(`dataManage.accountClass.index.请选择你要编辑的账目分类`))
                return
            }
        } else if (mode === "look") {
            if (!Object.keys(selectInfo.rowInfo).length) {
                message.warning(t(`dataManage.accountClass.index.请选择你要查看的账目分类`))
                return
            }
        }
        setShowMode(mode)
        setShowVisible(true)
    }

    //开关
    // const clientSweitchChange = (checked, e, id) => {
    //     e.stopPropagation()
    //     bussinessCategoryUpdate({id, deleteFlag : checked ? 0 : 1}).then((res) => {
    //         message.success("操作成功")
    //         loadData(1)
    //     })
    // }

    //table配置
    const columns = [
        
        {
            title: t(`dataManage.accountClass.index.导航图片`),
            align: "center",
            dataIndex: "categoryImg",
            render: (text) => (text ? <Image src={`${fileLookUrl().image}${text}`} width={34} height={34} key={text} /> : ""),
        },
        {
            title: t(`dataManage.accountClass.index.名称`),
            align: "center",
            dataIndex: "categoryName",
        },
        {
            title: t(`dataManage.accountClass.index.属性`),
            align: "center",
            dataIndex: "categoryType",
            render: (text) => (AccountClassStatus[text]),
        },
        {
            title: t(`dataManage.accountClass.index.排序`),
            align: "center",
            dataIndex: "categorySort",
        },
        // {
        //     title: "操作",
        //     align: "center",
        //     width: "12%",
        //     dataIndex: "deleteFlag",
        //     render: (text, record) => (
        //         <Switch size="small" checked={text === 0 ? true : false} onChange={(checked, e) => clientSweitchChange(checked, e, record.id)} />
        //     ),
        // },
        // {
        //     title: "备注",
        //     align: "center",
        //     dataIndex: "userAccount",
        // },
    ]
    //搜索JSON
    const searchList = {
        // normalList: [
        //     {
        //         type: "input",
        //         placeholder: "用户名称",
        //         valueName: "userName",
        //     },
        //     {
        //         type: "input",
        //         placeholder: "用户手机号",
        //         valueName: "userPhone",
        //     },
        //     {
        //         type: "input",
        //         placeholder: "用户名",
        //         valueName: "userAccount",
        //     },
        // ],
    }

    return (
        <>
            {state.activeMenu === "accountClass" && (
                <>
                    <ListComponent
                        title={t(`dataManage.accountClass.index.账目分类`)}
                        buttons={topButtons}
                        selectInfo={selectInfo}
                        columns={columns}
                        dataSource={list}
                        pagination={pagination}
                        onTableChange={onTableChange}
                        setSelectInfo={(obj) => setSelectInfo(obj)}
                        scroll={{ x: 'max-content' }}
                    />

                    {showVisible && (
                        <Detail
                            rowInfo={selectInfo.rowInfo}
                            visible={showVisible}
                            mode={showMode}
                            setVisible={setShowVisible}
                            onSuccess={() => {
                                loadData(1, searchValue)
                            }}
                        />
                    )}
                </>
            )}
        </>
    )
}
